import { Media } from '@bpm-web-app/download-api-sdk';
import classNames from 'classnames';
import { isDownloadLimitReached } from '@bpm-web-app/utils';
import styles from './versions-column.module.css';
import ArrowDownTriangle from '../../../../assets/icons/arrow-down-triangle.svg';
import DownloadIcon from '../../../../assets/icons/download.svg';

interface VersionsColumnProps {
    versionsList: Media[];
    onMoreVersionsClick?: () => void;
    onVersionClick?: (version: Media) => void;
    isAccordionOpen: boolean;
    isPremiumOnly?: boolean;
    hasPremiumOnlyAccess?: boolean;
    setCurrentMediaInContext?: () => void;
}

export function getVersionPillLabel(version: string) {
    return version
        .split(' ')
        .slice(0, 3)
        .map((c) => c.charAt(0).toUpperCase());
}
const pillsLimit = 4;

function VersionsColumn({ versionsList, onMoreVersionsClick, onVersionClick, isAccordionOpen, isPremiumOnly, hasPremiumOnlyAccess, setCurrentMediaInContext }: VersionsColumnProps) {
    if (isPremiumOnly && !hasPremiumOnlyAccess) {
        return (
            <div className={classNames('hide-filters-open', styles['versions-column'])}>
                <button
                    type="button"
                    className={classNames(styles['versions-column__upgrade-to-unlock'])}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (setCurrentMediaInContext) setCurrentMediaInContext();
                    }}>
                    UPGRADE TO UNLOCK
                </button>
            </div>
        );
    }

    const pillComponent = (media: Media) => {
        return (
            <button
                type="button"
                key={media.id}
                className={classNames(styles['versions-column__pill'], { [styles['versions-column__pill__downloaded']]: media.download_count })}
                disabled={isDownloadLimitReached(media.download_count)}
                data-tip={media.version?.name}
                onClick={(e) => {
                    e.stopPropagation();
                    onVersionClick?.(media);
                }}>
                <span className={styles['versions-column__pill__text']}>
                    {getVersionPillLabel(media.version?.name)}
                </span>
                <span className={styles['versions-column__pill__download']}>
                    <DownloadIcon />
                </span>
            </button>
        );
    };

    return (
        <div className={classNames('hide-filters-open', styles['versions-column'])}>

            <div className={classNames(styles['versions-column'], styles['versions-column__desktop'])}>{versionsList.slice(0, pillsLimit).map((media) => (
                pillComponent(media)
            ))}
            </div>

            <div className={classNames(styles['versions-column'], styles['versions-column__from-large-desktop'])}>{versionsList.map((media) => (
                pillComponent(media)
            ))}
            </div>
            {versionsList.length > pillsLimit && (
                <button
                    type="button"
                    className={classNames(styles['versions-column__more-versions-btn'], { [styles['versions-column__more-versions-btn--open']]: isAccordionOpen })}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMoreVersionsClick?.();
                    }}
                >
                    {`+${versionsList.length - pillsLimit} More`}
                    <ArrowDownTriangle />
                </button>
            )}
        </div>
    );
}
export default VersionsColumn;
